@if (isActive) {
  <pas-spinner [size]="'medium'"></pas-spinner>
}
